<template>
  <form @submit.prevent="">
    <md-card class="edit-profile">
      <md-card-header
        class="md-card-header-icon"
      >
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          Edit Profile - <small>Complete your profile</small>
        </h4>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>First Name</label>
              <md-input v-model="user.first_name" type="text"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Last Name</label>
              <md-input v-model="user.last_name" type="text"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Company</label>
              <md-input v-model="user.company_name" disabled></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Company Position</label>
              <md-input v-model="user.company_position"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Email Address</label>
              <md-input v-model="user.email" type="email"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Phone Number</label>
              <md-input v-model="user.phone_number" type="text"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100 toggle-nots">
              <label class="nots-label">Receive Notifications</label>
              <md-switch v-model="user.notification_option">{{user.notification_option ? 'On' : 'Off'}}</md-switch>
          </div>
          <div class="md-layout-item md-size-100 text-right">
            <md-button class="md-raised md-success mt-4" @click="emitToParent"
              >Update Profile</md-button
            >
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import api from "@/api";
// import store from "@/store";
export default {
  name: "edit-profile-form",
  props: {
    user: Object
  },
  data() {
  },
  methods: {
    emitToParent(event) {
      this.$emit("childToParent", this.user);
    }
  }
};
</script>
<style></style>
